export const STAT_PASSWORD = 'iamwhatiam'